const themeDark = {
  bg: "linear-gradient(135deg, #0b0f19, #0c125bff)",
  card: "rgba(255,255,255,0.06)",
  text: "#e0e6ff",
  muted: "#94a3b8",
  border: "rgba(255,255,255,0.12)",
  glow: "0 0 12px rgba(80,140,255,0.35)",
  primary: "#4e7cff",
  primaryHover: "#6d8dff",
  secondary: "rgba(80,140,255,0.15)",
  glass: "rgba(20,25,40,0.35)",

  //logo
  logoBackground: "linear-gradient(135deg, #4e7cff, #7dd3fc, #4e7cff)",

  // gradient bars / effects used in SectionHeader and Header
  gradientBar:
    "linear-gradient(90deg, rgba(78,124,255,0.9), rgba(125,211,252,0.9), rgba(78,124,255,0.9))",
  barshadow: "rgba(120,180,255,0.7)",

  // textarea:
  textAreaBackground: "rgba(255,255,255,0.05)",
  textAreaBoxshadow: "rgba(0,0,0,0.15)" ,

  // Tip:
  tipBackground: "rgba(255,255,255,0.06)",
  tipBoxshadow: "rgba(120,180,255,0.25)",

  // full-page dark background
  pageBackground: "linear-gradient(135deg, #0b0f19, #0d167eff)",

  
  //nav
  navText: "rgba(200,200,255,0.6)",      
  navTextActive: "#ffffff",              
  navTextHover: "#ffffff",              
  navActiveBackground: "linear-gradient(135deg, #4e7cff, #7dd3fc)",
  navHoverBackground: "rgba(120,180,255,0.25)",    
  navHoverShadow1: "rgba(120,180,255,0.9)",
  navHoverShadow2: "rgba(120,180,255,0.6)" ,
  navcard: "rgba(20,25,40,0.90)",
  navBorder: "rgba(255, 255, 255, 0.73)",

  //Error
  errorBackground: "rgba(255, 80, 80, 0.12)",
  errorBorder: "rgba(255, 80, 80, 0.35)",
  errorText: "#ff9b9b",

  //Highlight
  textHighlight: "#ffffff"
};
export default themeDark;
